"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MomentColumnConfigFormat = void 0;
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const ColumnConfig_1 = tslib_1.__importDefault(require("./ColumnConfig"));
const __1 = require("..");
const GridColumnDataDisplayedType_1 = require("../GridColumnDataDisplayedType");
var MomentColumnConfigFormat;
(function (MomentColumnConfigFormat) {
    MomentColumnConfigFormat["DATE"] = "DD-MM-YYYY";
    MomentColumnConfigFormat["DATE_TIME"] = "DD-MM-YYYY HH:mm";
    MomentColumnConfigFormat["DATE_TIME_SECONDS"] = "DD-MM-YYYY HH:mm:ss";
})(MomentColumnConfigFormat = exports.MomentColumnConfigFormat || (exports.MomentColumnConfigFormat = {}));
class MomentColumnConfig extends ColumnConfig_1.default {
    static extractMomentColumnArgs(args) {
        if (args.length > 1) {
            const [momentFormat, heading, headerStyle, mapDataToTD, sortable, clickable, footers] = args;
            return {
                clickable,
                footers,
                headerStyle,
                heading,
                mapDataToTD,
                momentFormat,
                sortable
            };
        }
        return args[0];
    }
    constructor(...args) {
        super({
            ...MomentColumnConfig.extractMomentColumnArgs(args),
            wordWrap: __1.TDWordWrap.NO_WRAP
        });
        const { momentFormat, unknownDateLabel = "-", emptyOldest = false } = MomentColumnConfig.extractMomentColumnArgs(args);
        this.unknownDateLabel = unknownDateLabel;
        this.mapDataToSortValue = this.mapDataToSortValue ?? (data => {
            const mappedData = this.mapDataToTD(data);
            if (!mappedData) {
                return emptyOldest ? new Date(2999, 11, 31) : new Date(0, 0, 0);
            }
            return new Date(mappedData);
        });
        this.momentFormat = momentFormat ?? MomentColumnConfigFormat.DATE;
        this.renderer = {
            canRender: (date) => this.canRender(date),
            render: (html, date) => this.render(html, date)
        };
    }
    canRender(_) {
        return true;
    }
    render(renderingContext, date) {
        renderingContext.setColumnDataDisplayType(GridColumnDataDisplayedType_1.GridColumnDataDisplayedType.DATE);
        if (!date || (date instanceof Date && isNaN(date.valueOf()))) {
            renderingContext.html(this.unknownDateLabel);
            return;
        }
        try {
            const momentDate = (0, fmko_ts_common_1.getMoment)(date);
            const formattedDate = momentDate.format(this.momentFormat);
            renderingContext.html(formattedDate);
        }
        catch (error) {
            renderingContext.html("-");
        }
    }
}
exports.default = MomentColumnConfig;
//# sourceMappingURL=MomentColumnConfig.js.map